<button class="botao-fechar" (click)="fechar()">
  <span class="botao-fechar__icone-botao"></span>
</button>